import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const track = (event, path = "", meta = {}) => {
  api.post("/analytics/event", { event, path, meta }).catch(() => {});
};


export const errorText = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => x?.msg || String(x)).join(". ") || fallback;
  return typeof d === "string" && d ? d : fallback;
};

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || "");
